
import XHeader from 'vux/src/components/x-header/index.vue'

import ewmImg from './images/ewmImg.jpg'
export default {
data(){
return{
ewmImg
}
},
components: {
XHeader
},
}



// WEBPACK FOOTER //
// ./src/project/articleProject/appointmentPresentation.vue